var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconClearsearch = function SvgIconClearsearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.38062.3664103c.47874-.455365 1.23304-.4868652 1.748522-.0913015l.106617.0913015 4.375698 4.1874353L10.988396.3664103c.512935-.4892026 1.342204-.4878911 1.855139 0 .507493.4892026.507493 1.280714 0 1.7699166L8.217592 6.559479l4.625943 4.421841c.507493.489202.507493 1.280714 0 1.769916-.512935.488547-1.342204.488547-1.855139 0L6.611457 8.564129l-4.375698 4.187107c-.47874.455977-1.233041.486376-1.748522.091196l-.106617-.091196c-.47366-.456589-.505238-1.176522-.094732-1.668224l.094732-.101692 4.625943-4.421841L.38062 2.1363269c-.507493-.4892026-.507493-1.280714 0-1.7699166z",
    fill: "#A1B4B6",
    fillRule: "nonzero"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconClearsearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_clearsearch.e7b18936.svg";
export { ForwardRef as ReactComponent };